<template>
    <div class="h-100">
        <Header />
        <div
            class="tab-content content-height"
            :class="
                isMobile
                    ? 'suggestions-tab-content-mobile'
                    : 'suggestions-tab-content'
            "
            id="myTabContent"
        >
            <div
                class="tab-pane fade show active h-100"
                id="all"
                role="tabpanel"
                aria-labelledby="all-tab"
            >
                <div class="card h-100">
                    <div class="card-body p-0">
                        <div
                            class="row m-0 w-100 align-items-center padding-l-10 padding-r-10 padding-t-10 justify-content-start filter-block"
                        >
                            <div v-if="selectedCategory?.value" @click="removeSelectedCategory" class="pointer d-flex align-items-center justify-content-center padding-b-20 padding-l-10 padding-t-10">
                                <svg  width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M9.2069 10.4194L14.7931 5L16.5 6.65591L10.9138 12.0753L16.5 17.3441L14.7931 19L9.2069 13.7312L7.5 12.0753L9.2069 10.4194Z" fill="#006BE6"/>
                                </svg>
                            </div>
                            <SearchInput @handleSearch="handleSearch" />
                            <div
                                class="col h-100 d-flex align-items-center justify-content-start padding-b-20 padding-r-10 padding-l-10 padding-t-10"
                            >
                                <div>
                                    <svg
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M11.1914 16.04H12.7268V11.0299H11.1914V16.04Z"
                                            fill="#006BE6"
                                        />
                                        <path
                                            d="M12.8076 7.87891H11.1914V9.49507H12.8076V7.87891Z"
                                            fill="#006BE6"
                                        />
                                        <path
                                            d="M12 4C7.55556 4 4 7.55556 4 12C4 16.4444 7.55556 20 12 20C16.4444 20 20 16.4444 20 12C20 7.55556 16.3636 4 12 4ZM12 18.303C8.44444 18.303 5.61616 15.4747 5.61616 12C5.61616 8.52525 8.44444 5.61616 12 5.61616C15.5556 5.61616 18.3838 8.44444 18.3838 12C18.3838 15.5556 15.4747 18.303 12 18.303Z"
                                            fill="#006BE6"
                                        />
                                    </svg>
                                </div>
                                <div class="pl-2">
                                    <span class="small">
                                        Ստուգել էլ․ ստորագրությունների
                                        վավերականությունը՝
                                        <a
                                            href="https://www.ekeng.am/hy/sec_sub/sign_check"
                                            target="_blank"
                                            class="small pointer font-weight-bold text-primary"
                                            >Ստուգել
                                        </a>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="row w-100 m-0">
                            <div class="col-12 tenders-list p-0">
                                <div class="d-flex flex-column padding-10">
                                    <div class="d-flex flex-wrap gap-2">
                                        <template v-if="hasSelectedCategory">
                                            <order-tender-card
                                                v-for="order in orders"
                                                :key="order.order_id"
                                                :order="order"
                                                :selectedType="'seller'"
                                                :can-edit="false"
                                                :hasContractHtml="
                                                Boolean(
                                                    contractHtml &&
                                                        selectedOrder.order_id ===
                                                            order.order_id
                                                )
                                            "
                                                @handleOpenContract="
                                                handleOpenContract
                                            "
                                                @handleConfirmOrder="
                                                handleConfirmOrder
                                            "
                                                @handleCancelOrder="
                                                handleCancelOrder
                                            "
                                            />
                                        </template>
                                        <template v-else>
                                            <category-card
                                                :category="category"
                                                :selectedCategory="
                                                    selectedCategory
                                                "
                                                @clickMethod="
                                                    handleSelectCategory
                                                "
                                                :show-count="true"
                                                v-for="(category, index) in timelessTendersCategories.filter(cat => cat.count)"
                                                :key="index"
                                            />
                                        </template>

                                    </div>
                                </div>
                            </div>
                            <invoice-details-modal />
                            <change-status-modal />
                            <timeless-order-cancel-modal />
                            <new-editor-modal
                                :openedBy="'seller'"
                                :contractHtml="contractHtml"
                                :order="selectedOrder"
                                :tender="contractData"
                                @handleGetContract="handleGetContract"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import InvoiceDetailsModal from './modals/InvoiceDetailsModal.vue'
import isMobile from '@/mixins/isMobileView'
import ChangeStatusModal from './modals/ChangeStatusModal.vue'
import Header from '@/views/private/participant/timelessTenders/header.vue'
import OrderTenderCard from '@/components/timelessTenders/orderTenderCard.vue'
import NewEditorModal from '@/views/fileManagment/timeless/NewEditorModal.vue'
import TimelessOrderCancelModal from '@/components/helpers/TimelessOrderCancelModal.vue'
import SearchInput from '@/components/timelessTenders/SearchInput.vue'
import CategoryCard from '@/components/timelessTenders/categoryCard.vue'

export default {
    data() {
        return {
            proxyUrl: process.env.VUE_APP_API_URL,
            orders: [],
            allOrders: [],
            selectedCategory: {},
            categoryCounts: {},
            hasSelectedCategory: false,
            selectedOrder: {},
            searchQuery: '',
            contractHtml: '',
            contractSign: '',
            contractData: {
                rows: [
                    {
                        name: 'name',
                        specification: 'specification',
                        unit: 'unit',
                        count: 'count',
                        terms_of_purchase: 'terms_of_purchase',
                        delivery_terms: 'delivery_terms',
                        offer_delivery_terms: 'offer_delivery_terms',
                        payment_terms: 'payment_terms',
                        delivery_address: 'delivery_address',
                    },
                ],
            },
            filters: {
                status: { name: 'Բոլորը', value: 'all' },
                statusOptions: [
                    { name: 'Բոլորը', value: 'all' },
                    { name: 'Ակտիվ առաջարկներ', value: 'active' },
                    { name: 'Ավարտված առաջարկներ', value: 'finished' },
                ],
            },
        }
    },
    mixins: [isMobile],
    components: {
        CategoryCard,
        SearchInput,
        NewEditorModal,
        OrderTenderCard,
        Header,
        InvoiceDetailsModal,
        ChangeStatusModal,
        TimelessOrderCancelModal,
    },
    mounted() {
        this.getOrders()
    },
    computed: {
        timelessTendersCategories() {
            const base = this.$store.getters['settings/timelessTendersCategories'];
            return base.map((category) => ({
                ...category,
                count: this.categoryCounts?.[category.value] || 0
            }));
        },
    },
    methods: {
        handleSearch(query) {
            this.searchQuery = query
            this.getOrders()
        },
        getOrders() {
            this.$client
                .get('timeless-tenders/userOrders', {
                    params: {
                        query: this.searchQuery,
                        category: this.selectedCategory?.value ?? '',
                    },
                })
                .then(({ data }) => {
                    console.log('data', data)
                    if (!this.hasSelectedCategory) {
                        this.allOrders = data;
                        this.updateCategoryCounts();
                    } else {
                        this.orders = data
                    }
                })
                .finally(() => {
                    this.refreshTimelessMenuNotifications();
                })
        },
        updateCategoryCounts() {
            const counts = {};
            this.allOrders.forEach((order) => {
                const category = order.tender.category;
                if (category) {
                    counts[category] = (counts[category] || 0) + 1;
                }
            });
            this.categoryCounts = counts;
        },
        handleSelectCategory(category) {
            if(category.count){
                this.selectedCategory = category
                this.hasSelectedCategory = true
                this.getOrders()
            }
        },
        removeSelectedCategory(){
            this.orders = [];
            this.selectedCategory = {}
            this.hasSelectedCategory = false
        },
        handleConfirmOrder({ order }) {
            console.log('handleConfirmOrder', order)

            this.$client
                .post(`timeless-tenders/confirmOrder/${order.order_id}`, {
                    sign: this.contractSign,
                })
                .then(({ data }) => {
                    if (data) {
                        this.$notify({
                            group: 'foo',
                            type: 'success',
                            text: 'Հաջողությամբ հաստատված է',
                        })
                        this.$client
                            .get('timeless-tenders/userOrders')
                            .then(({ data }) => {
                                console.log('data', data)
                                this.orders = data
                            })
                            .finally(() => {
                                this.refreshTimelessMenuNotifications()
                            })
                    }
                    this.selectedOrder = {}
                })
                .catch(() => {
                    this.$notify({
                        group: 'foo',
                        type: 'error',
                        text: 'Ինչ որ բան այն չէ, կրկին փորձեք!',
                    })
                })
        },
        handleCancelOrder({ order }) {
            console.log('handleCancelOrder', order)

            this.$modal.show('timeless-order-cancel-modal', {
                msg: 'tender',
                callback: async () => {
                    this.$client
                        .post(`timeless-tenders/cancelOrder/${order.order_id}`)
                        .then(({ data }) => {
                            if (data) {
                                this.$modal.hide('timeless-order-cancel-modal')
                                this.$notify({
                                    group: 'foo',
                                    type: 'success',
                                    text: 'Հաջողությամբ հաստատված է',
                                })
                                this.$client
                                    .get('timeless-tenders/userOrders')
                                    .then(({ data }) => {
                                        console.log('data', data)
                                        this.orders = data
                                    })
                                    .finally(() => {
                                        this.refreshTimelessMenuNotifications()
                                    })
                            }
                            this.selectedOrder = {}
                        })
                        .catch(() => {
                            this.$modal.hide('timeless-order-cancel-modal')
                            this.$notify({
                                group: 'foo',
                                type: 'error',
                                text: 'Ինչ որ բան այն չէ, կրկին փորձեք!',
                            })
                        })
                },
            })
        },
        handleOpenContract({ order }) {
            console.log('handleOpenContract')
            this.selectedOrder = order
            this.contractHtml = ''

            this.$modal.show('new-editor-modal', {
                action: 'download',
                fileName: 'contract_draft',
                editorTitle: 'Պայմանագրի նախագիծ',
            })
        },
        selectPage(event) {
            this.$router.push(event.target.value)
        },
        async resetComponent() {
            await this.$refs.vtable.refresh()
        },
        async handleGetContract(contract, signedDocument) {
            this.contractHtml = contract
            this.contractSign = signedDocument
            console.log('contractSign', this.contractSign)
            this.$modal.hide('new-editor-modal')
        },
        refreshTimelessMenuNotifications() {
            this.$store.dispatch('user/getMenuNotifications')
        },
    },
}
</script>
